// extracted by mini-css-extract-plugin
export default {"inputContainer":"styles_inputContainer__j1LE8","labelContainer":"styles_labelContainer__f8Y+o","input":"styles_input__LrFPf","commonOption":"styles_commonOption__s992q"};